// @ts-check
import BlockCard from '../BlockCard';
import { STAGE_ORDER, label } from '../../../utils/wholesale';

/** Stage bar of wholesale partners per pipeline stage; the follow-ups list itself stays in the RemindersPanel above the grid. */
export default function WholesaleBlock({ block }) {
  const { by_stage: byStage = {}, overdue = 0 } = block.data || {};
  const known = new Set(STAGE_ORDER);
  const rows = [
    ...STAGE_ORDER.filter((k) => byStage[k] > 0).map((k) => ({ key: k, label: label(k), count: byStage[k] })),
    // Stages added to the backend enum later still show.
    ...Object.keys(byStage).filter((k) => !known.has(k) && byStage[k] > 0).map((k) => ({ key: k, label: label(k), count: byStage[k] })),
  ];
  const max = Math.max(0, ...rows.map((r) => r.count));

  return (
    <BlockCard title="Wholesale" href={block.href} headline={block.headline}>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground">No partners yet</p>
      ) : (
        <ul className="space-y-2">
          {rows.map((r) => (
            <li key={r.key} data-testid="wholesale-stage" className="text-sm">
              <div className="flex items-center justify-between">
                <span>{r.label}</span>
                <span className="font-medium">{r.count}</span>
              </div>
              <div className="mt-1 h-2 rounded bg-muted">
                <div data-testid="wholesale-bar" className="h-2 rounded bg-primary" style={{ width: `${(r.count / max) * 100}%` }} />
              </div>
            </li>
          ))}
        </ul>
      )}
      {overdue > 0 && (
        <p className="mt-3 text-sm text-muted-foreground" data-testid="wholesale-overdue">
          <span className="font-semibold text-foreground">{overdue} overdue</span>
        </p>
      )}
    </BlockCard>
  );
}
